var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipedrive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 7,
    fill: "#017737"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.2 7.5c-2.2 0-3.5 1-4.1 1.7l-.1-1.4H9v16.9h4.1v-5.3c.7.6 1.9 1 3.3 1 3.7 0 6.6-2.9 6.6-6.5 0-3.9-2.3-6.4-5.8-6.4zm-.9 9.5c-2 0-3.3-1.4-3.3-3.1 0-2 1.5-3.1 3.2-3.1 1.8 0 3.1 1.3 3.1 3.1 0 2-1.4 3.1-3 3.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipedrive);
export default __webpack_public_path__ + "static/media/pipedrive.272a00600d5bb7a1ef312de7a6c61653.svg";
export { ForwardRef as ReactComponent };